<template>
    <div class="position-relative">
        <div class="dropdown" v-if="isLoggedIn">
            <a href="#" class="dropdown-toggle nav-link" id="accountMenuList" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-boundary="window">
              <svg width="32" height="32">
                <title>Mein Konto</title>
                <desc>Benutzerkonto-Symbol</desc>
                <path d="M16.00058,16.99345c1.64697,0,3.29492-.59863,4.54883-1.7959,1.23047-1.1748,1.90771-2.73926,1.90771-4.40723,0-1.66699-.67725-3.23145-1.90771-4.40625-2.50781-2.39355-6.58887-2.39258-9.09766,0-1.23096,1.1748-1.90869,2.73926-1.90869,4.40625,0,1.66797.67773,3.23242,1.9082,4.40723,1.25439,1.19727,2.90137,1.7959,4.54932,1.7959ZM12.83261,7.83134c.87354-.83398,2.02051-1.25098,3.16797-1.25098,1.14697,0,2.29443.41699,3.16797,1.25098.83105.79297,1.28857,1.84375,1.28857,2.95898,0,1.11621-.45752,2.16699-1.28857,2.95996-1.74707,1.66797-4.58984,1.66797-6.33594,0-.83154-.79297-1.28955-1.84473-1.28955-2.95996,0-1.11426.45801-2.16602,1.28955-2.95898Z" style="fill: #303239; stroke-width: 0px;"></path>
                <path d="M16.00058,17.84111c-5.52344,0-10.01709,3.84766-10.01709,8.57715v1h20.03271v-1c0-4.72949-4.49316-8.57715-10.01562-8.57715ZM8.07578,25.41826c.58936-3.15332,3.91846-5.57715,7.9248-5.57715,4.00537,0,7.33398,2.42383,7.92334,5.57715h-15.84814Z" style="fill: #303239; stroke-width: 0px;"></path>
              </svg>
            </a>
            <div class="dropdown-menu small m-0 p-0 mw-100">
                <div class="list-group" aria-labelledby="accountMenuList" >
                    <a :href="$ceres.urls.myAccount" class="list-group-item small"><i class="fa fa-user" aria-hidden="true"></i> {{ $translate("Ceres::Template.loginMyAccount") }}</a>
                    <a href="#" class="list-group-item small" v-logout><i class="fa fa-sign-out" aria-hidden="true"></i> {{ $translate("Ceres::Template.loginLogout") }}</a>
                </div>
            </div>
        </div>
        <div v-if="!isLoggedIn">
          <a class="nav-link" data-testing="login-select" v-if="showLogin" :href="isLogin ? 'javascript:void(0)' : '#login'" :data-toggle="isLogin ? false : 'modal'" @click="createLoginModal(); unmarkInputFields();" :aria-label="$translate('Ceres::Template.login')">
            <svg width="32" height="32">
              <title>Mein Konto</title>
              <desc>Benutzerkonto-Symbol</desc>
              <path d="M16.00058,16.99345c1.64697,0,3.29492-.59863,4.54883-1.7959,1.23047-1.1748,1.90771-2.73926,1.90771-4.40723,0-1.66699-.67725-3.23145-1.90771-4.40625-2.50781-2.39355-6.58887-2.39258-9.09766,0-1.23096,1.1748-1.90869,2.73926-1.90869,4.40625,0,1.66797.67773,3.23242,1.9082,4.40723,1.25439,1.19727,2.90137,1.7959,4.54932,1.7959ZM12.83261,7.83134c.87354-.83398,2.02051-1.25098,3.16797-1.25098,1.14697,0,2.29443.41699,3.16797,1.25098.83105.79297,1.28857,1.84375,1.28857,2.95898,0,1.11621-.45752,2.16699-1.28857,2.95996-1.74707,1.66797-4.58984,1.66797-6.33594,0-.83154-.79297-1.28955-1.84473-1.28955-2.95996,0-1.11426.45801-2.16602,1.28955-2.95898Z" style="fill: #303239; stroke-width: 0px;"></path>
              <path d="M16.00058,17.84111c-5.52344,0-10.01709,3.84766-10.01709,8.57715v1h20.03271v-1c0-4.72949-4.49316-8.57715-10.01562-8.57715ZM8.07578,25.41826c.58936-3.15332,3.91846-5.57715,7.9248-5.57715,4.00537,0,7.33398,2.42383,7.92334,5.57715h-15.84814Z" style="fill: #303239; stroke-width: 0px;"></path>
            </svg>
          </a>
        </div>
    </div>
</template>

<script>
import ValidationService from "../services/ValidationService";
import { mapGetters, mapActions } from "vuex";

export default {
    props: {
        showRegistration: {
            type: Boolean,
            default: true
        },
        showLogin: {
            type: Boolean,
            default: true
        }
    },

    computed: {
        ...mapGetters([
           "username",
           "isLoggedIn"
        ])
    },

    data()
    {
        return {
            isLogin: App.templateType === "login",
            isRegister: App.templateType === "register"
        };
    },

    methods: {
        unmarkInputFields()
        {
            ValidationService.unmarkAllFields($("#login"));
            ValidationService.unmarkAllFields($("#registration"));
        },

        createLoginModal()
        {
            this.loadComponent("login-modal");
        },

        createRegisterModal()
        {
            this.loadComponent("register-modal");
        },

        ...mapActions([
            "loadComponent"
        ])
    }
}
</script>
